import React, { useState } from "react";
import { requestPasswordReset, RequestResetResponse, authErrorMessage } from "@/api/auth_api.ts";
import { AxiosError } from "axios";
import { Input } from "@/components/ui/input.tsx";
import { Errors, FormError } from "@/pages/RegistrationPage.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Link } from "wouter";

const RecoverPasswordPage: React.FC = (props) => {
	const [email, setEmail] = useState("");
	const [errors, setErrors] = useState<RequestResetResponse["errors"]>(undefined);
	const [formError, setFormError] = useState<string>();
	const [sent, setSent] = useState(false);

	const handleSubmit = async (e: React.BaseSyntheticEvent) => {
		e.preventDefault();
		setErrors({});
		setFormError(undefined);

		try {
			const response = await requestPasswordReset(email);
			if (response.ok == true) {
				setSent(true);
			}
		} catch (e) {
			if (e instanceof AxiosError && e.response?.data?.errors) {
				setErrors(e.response.data.errors);
			}
			setFormError(authErrorMessage(e));
			return;
		}
	};

	return (
		<div className={"flex justify-center items-center h-screen"}>
			<form
				onSubmit={handleSubmit}
				target={"#"}
				className={"flex flex-col gap-4 flex-1 w-full max-w-[300px] p-4"}
			>
				<h2 className={"text-xl font-bold"}>Reset Password</h2>
				<FormError error={formError} />
				<label>
					Email
					<Input
						type="text"
						name={"email"}
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<Errors errors={errors} field={"email"} />
				</label>
				<div className={"flex justify-between items-center"}>
					{!sent ? (
						<Button
							type={"submit"}
							className={"w-full sm:w-6/12"}
						>
							Request Reset
						</Button>
					) : (
						<div className={"text-green-400"}>Email Sent</div>
					)}
					<Link
						className={"text-secondary-foreground/80"}
						to={"/login"}
					>
						Login
					</Link>
				</div>
			</form>
		</div>
	);
};

export { RecoverPasswordPage };
